/* Holland Padel – rustige klantreis voor bezoekers die al willen kopen (concept 22-10-2026).
   1. Live chat-knop weg zolang de winkelwagen open is (mobiel) en op /cart (mobiel): CSS in snippets/hp-funnel-fix.liquid.
   2. Klaviyo-kortingspopup niet tonen aan wie al een actiecode heeft (link /discount/...),
      via een betaalde advertentie binnenkomt (utm_medium=paid) of al iets in de winkelwagen heeft.
   3. Wie met code HALLOWEEN binnenkomt ziet bovenaan de pagina dat de code klaarstaat
      en dat hij het cadeau in de winkelwagen kiest (t/m 31-10-2026).
   Weghalen: dit bestand + snippets/hp-funnel-fix.liquid + de render-regel in layout/theme.liquid. */
(function () {
  var KEY = 'hpKoper';

  function cookie(naam) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + naam + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
  }

  // Onthoud voor deze sessie dat de bezoeker via een advertentie of met een code kwam.
  try {
    var p = new URLSearchParams(location.search);
    if (p.get('utm_medium') === 'paid' || cookie('discount_code')) sessionStorage.setItem(KEY, '1');
  } catch (e) {}

  function heeftCadeauCode() { return /^halloween$/i.test(cookie('discount_code')); }
  function isKoper() {
    var s = false;
    try { s = sessionStorage.getItem(KEY) === '1'; } catch (e) {}
    return s || !!cookie('discount_code') || (window.HP_CART_COUNT || 0) > 0;
  }

  /* ---------- 2. Klaviyo-popup onderdrukken ---------- */
  var POPUP = 'div[role="dialog"][aria-label="POPUP Form"]';
  function wagenGevuld() {
    return fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { return (c.item_count || 0) > 0; })
      .catch(function () { return false; });
  }
  // Netjes sluiten via Klaviyo's eigen sluitknop: heft ook de scroll-blokkade op en Klaviyo
  // onthoudt dat hij dicht is. Klaviyo sluit met een animatie, dus de popup wordt alleen
  // onzichtbaar gemaakt (geen display:none, anders loopt de animatie niet af). De knop werkt
  // soms pas na een moment: blijven proberen tot de popup weg is (max ~10 s).
  function sluit(popup, poging) {
    poging = poging || 0;
    document.documentElement.classList.add('hp-popup-verberg');
    if (!document.contains(popup)) { document.body.classList.remove('klaviyo-prevent-body-scrolling'); return; }
    var knop = popup.querySelector('.klaviyo-close-form');
    if (knop && poging % 5 === 0) knop.click();
    if (poging < 50) setTimeout(function () { sluit(popup, poging + 1); }, 200);
    else document.body.classList.remove('klaviyo-prevent-body-scrolling');
  }
  var bezig = false;
  function check(popup) {
    if (!popup || bezig || popup.dataset.hpGecheckt) return;
    if (isKoper()) { popup.dataset.hpGecheckt = '1'; sluit(popup); return; }
    bezig = true;
    wagenGevuld().then(function (vol) {
      bezig = false; popup.dataset.hpGecheckt = '1';
      if (vol) sluit(popup);
    });
  }
  // Verberg alvast (geen flits) als we zeker weten dat het een koper is.
  if (isKoper()) document.documentElement.classList.add('hp-popup-verberg');
  new MutationObserver(function () {
    var p = document.querySelector(POPUP);
    if (p) check(p);
  }).observe(document.documentElement, { childList: true, subtree: true });
  // Na toevoegen aan de wagen geldt de bezoeker ook als koper.
  ['dispatch:cart-drawer:open', 'on:cart:add', 'on:line-item:change', 'on:cart:after-merge'].forEach(function (evt) {
    document.addEventListener(evt, function () { try { sessionStorage.setItem(KEY, '1'); } catch (e) {} });
  });

  /* ---------- 3. Halloween: code staat klaar ---------- */
  var EINDE = new Date('2026-10-31T23:59:59+01:00');
  function strook() {
    if (new Date() > EINDE || !heeftCadeauCode()) return;
    if (/\/(cart|checkouts?)(\/|$)/.test(location.pathname)) return;
    if (document.querySelector('.hp-hw-strook')) return;
    var taal = (window.Shopify && Shopify.locale) || 'nl';
    var t = {
      nl: ['Code HALLOWEEN staat klaar.', 'Kies je gratis cadeau in je winkelwagen (vanaf €150).'],
      en: ['Code HALLOWEEN is ready.', 'Choose your free gift in your cart (orders from €150).'],
      de: ['Code HALLOWEEN ist aktiv.', 'Wähle dein Gratisgeschenk im Warenkorb (ab 150 €).']
    }[taal.slice(0, 2)] || null;
    if (!t) return;
    var main = document.querySelector('main');
    if (!main) return;
    var div = document.createElement('div');
    div.className = 'hp-hw-strook';
    div.setAttribute('role', 'status');
    div.innerHTML = '<span aria-hidden="true">🎃</span> <strong></strong> <span class="hp-hw-strook__sub"></span>';
    div.querySelector('strong').textContent = t[0];
    div.querySelector('.hp-hw-strook__sub').textContent = t[1];
    main.insertBefore(div, main.firstChild);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', strook); else strook();
})();
